import { AnalyticsStore, ExperimentStore } from 'bernie-plugin-mobx';
import { inject, observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import {
  LodgingOnSubmitCallback,
  LodgingQueryParamsProvider,
  SearchForm,
  useLodgingURLParamsToQueryInputs,
} from '@shared-ui/search-tools-lodging';
import { useLocalization } from '@shared-ui/localization-context';

import { SearchResultsStore } from 'src/common/stores/search-results-store';

import { UitkSpacing } from 'uitk-react-spacing';

import { updateResultsWithNewCriteria } from './universal-search-form-utils';

export interface UniversalSearchFormWrapperProps {
  analytics?: AnalyticsStore;
  searchResults?: SearchResultsStore;
  experiment?: ExperimentStore;
}

const UniversalSearchFormWrapper: React.FC<UniversalSearchFormWrapperProps> = inject(
  'analytics',
  'searchResults',
  'experiment'
)(
  observer(({ analytics, searchResults, experiment }: UniversalSearchFormWrapperProps) => {
    const location = useLocation();
    const history = useHistory();
    const l10n = useLocalization();

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>, inputs) => {
      event.preventDefault();
      analytics?.resetAnalyticsForNewPage();

      updateResultsWithNewCriteria(inputs, location, history, searchResults, experiment, l10n);
    };

    return (
      <ErrorBoundary label="hotel.search.universal-search-form">
        <UitkSpacing margin={{ small: { inline: 'three', blockstart: 'three' }, medium: { inline: 'unset', block: 'unset' } }}>
          <div>
            <LodgingQueryParamsProvider urlSearchParams={new URLSearchParams(useLocation().search)}>
              <SearchFormWrapping handleSubmit={handleSubmit} />
            </LodgingQueryParamsProvider>
          </div>
        </UitkSpacing>
      </ErrorBoundary>
    );
  })
);

interface SearchFormWrappingProps {
  handleSubmit: LodgingOnSubmitCallback;
}

const SearchFormWrapping: React.FC<SearchFormWrappingProps> = ({ handleSubmit }) => {
  const inputs = useLodgingURLParamsToQueryInputs();
  const [skipQuery, setSkipQuery] = React.useState(false);
  React.useEffect(() => {
    setSkipQuery(true);
  }, []);

  return <SearchForm inputs={inputs ?? {}} onSubmit={handleSubmit} includePlayback skipQuery={skipQuery} />;
};

export const SharedUiUniversalSearchFormWrapper = UniversalSearchFormWrapper;
SharedUiUniversalSearchFormWrapper.displayName = 'SharedUiUniversalSearchFormWrapper';
